import { ReactNode } from "react";

export type CardProps = {
  classname?: string;
  children: ReactNode;
}

const Card = ({ classname, children }: CardProps): JSX.Element => {
  return <div className={`rounded-lg p-2w w-fit h-fit bg-white ${classname}`}>{children}</div>;
};

export default Card;